import { render, staticRenderFns } from "./ProductSetActivitiesList.vue?vue&type=template&id=8908dd34&scoped=true"
import script from "./ProductSetActivitiesList.vue?vue&type=script&lang=ts"
export * from "./ProductSetActivitiesList.vue?vue&type=script&lang=ts"
import style0 from "./ProductSetActivitiesList.vue?vue&type=style&index=0&id=8908dd34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8908dd34",
  null
  
)

export default component.exports